/** Sanitize Mermaid flowchart source to avoid subgraph / node ID collisions. */

function subgraphIds(source: string): Set<string> {
  const ids = new Set<string>();
  const re = /^\s*subgraph\s+(\w+)/gm;
  let match: RegExpExecArray | null;
  while ((match = re.exec(source)) !== null) {
    ids.add(match[1]!);
  }
  return ids;
}

/**
 * Rename node IDs that collide with subgraph IDs (e.g. subgraph `monitor` + node `monitor`).
 */
export function sanitizeMermaidSource(source: string): string {
  const text = (source || "").trim();
  if (!text) return text;

  const sgIds = subgraphIds(text);
  if (!sgIds.size) return text;

  const renames = new Map<string, string>();
  for (const sgId of sgIds) {
    renames.set(sgId, `${sgId}_node`);
  }

  return text
    .split("\n")
    .map((line) => {
      const stripped = line.trimStart();
      if (stripped.startsWith("subgraph ")) return line;

      let next = line;
      for (const [sgId, replacement] of renames) {
        if (new RegExp(`^\\s*${sgId}\\s*[\\[\\{\\(]`).test(line)) {
          next = next.replace(new RegExp(`\\b${sgId}\\b`), replacement);
        } else if (line.includes("-->") && new RegExp(`\\b${sgId}\\b`).test(line)) {
          next = next.replace(new RegExp(`\\b${sgId}\\b`, "g"), replacement);
        }
      }
      return next;
    })
    .join("\n");
}
